// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeStripsCustomGameRenameBody = {
  poolId: string;
  eventId: string;
  title: string;
};

export type typeStripsCustomGameRenameOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { eventId: string; title: string };
};

export type typeStripsCustomGameRenameOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsCustomGameRenameOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsCustomGameRenameOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaStripsCustomGameRenameBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    eventId: { type: "string", maxLength: 3000, minLength: 1 },
    title: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "eventId", "title"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createStripsCustomGameRename(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaStripsCustomGameRenameBody);
  }

  return async function postStripsCustomGameRename(
    payload: typeStripsCustomGameRenameBody,
  ): Promise<
    typeStripsCustomGameRenameOutput200 | typeStripsCustomGameRenameOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postStripsCustomGameRename" failed before calling the network. #981fef545dfe`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#981fef545dfe" },
        },
        data: null,
      } as typeStripsCustomGameRenameOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/strips/custom-game-rename`,
      httpMethod: "POST",
      options,
    })) as
      typeStripsCustomGameRenameOutput200 | typeStripsCustomGameRenameOutput400;
  };
}
